





























import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import RequestPromises from "@/mixins/requestPromises";
import Context from "@/mixins/context";

// Enums
import { DataModules } from "@/store/modules/data";
import { InvoiceCategoryCode } from "@/models/invoices";

// Types
import { IClient } from "@/models/clients";
import { IInvoice } from "@/models/invoices";

@Component({
  components: {
    "invoices-listing": () =>
      import("@/components/app/global/invoices/invoicesListing.vue")
  }
})
export default class ManualConsolidationModal extends Mixins(
  RequestPromises,
  Context
) {
  // Props

  @Prop({ required: true })
  public clientId!: IClient["id"];

  // Data

  public isProcessing = false;
  public selectedIds = [] as IInvoice["id"][];

  // Methods

  public async consolidateInvoices() {
    this.isProcessing = true;
    try {
      const invoice: IInvoice = await this.$store.dispatch(
        `data/${DataModules.INVOICES}/consolidateInvoices`,
        {
          vm: this,
          data: {
            invoice_ids: this.selectedIds
          }
        }
      );
      return this.$router
        .push(
          this.$store.getters[`data/${DataModules.INVOICES}/getRoute`](
            invoice.id,
            invoice.client_id
          )
        )
        .catch((this.$router as any).handleFailure);
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isProcessing = false;
    }
  }

  public updateSelectedIds(invoiceIds: IInvoice["id"][]) {
    this.selectedIds = invoiceIds;
  }

  public get listBindings() {
    return {
      id: "IPL1",
      ignoreHistory: true,
      clientId: this.clientId,
      dataScope: `$consolidatable::${this.clientId}`,
      isSelectable: true,
      selectedIds: this.selectedIds,
      manualFilters: () => ({
        "filter[status.code]": this.$store.getters[
          `data/${DataModules.INVOICES}/unpaidStatuses`
        ].join(),
        "filter[is_consolidation|neq]": true,
        "filter[category.slug]": InvoiceCategoryCode.RECURRENT,
        "filter[paid_amount]": 0
      }),
      // Here we return {} to prevent rows being created as router-links
      rowProps: () => ({}),
      rowEvents: (invoice: IInvoice) => ({
        click: () =>
          this.$store.dispatch(
            `data/${DataModules.INVOICES}/openPreviewModal`,
            {
              invoiceId: invoice.id
            }
          )
      })
    };
  }
}
